import './leftnavbar.scss';
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import React from 'react';
import { NavLink } from 'react-router-dom';
import NavbarDropdown from './NavDropDown';
import { AiFillHome } from 'react-icons/ai';
import { FaTasks, FaMoneyBillWave } from 'react-icons/fa';
import { HiOfficeBuilding } from 'react-icons/hi';
import { BsFillPersonBadgeFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { CgMediaLive } from 'react-icons/cg';
import { BsCardChecklist, BsGlobe } from 'react-icons/bs';
import { AiOutlineCalendar, AiOutlineTeam } from 'react-icons/ai';
import { BsTelephoneFill, BsCalendar3 } from 'react-icons/bs';
import { FiTarget } from 'react-icons/fi';
import { BiBarChart } from 'react-icons/bi';

const LeftNavBar = () => {
  const type = useSelector((state) => state.auth.role);
  const isUsAgent = useSelector((state) => state.auth.marketerDetails?.category === 'us_agent');
  // const type = 1;
  // const Username = useSelector((state) => state.auth.first_name);
  const name = useSelector((state) => state.auth.first_name);
  //snr_marketer, marketer

  // 1 for snr-marketer
  // 2 for marketer
  // 3 for agent
  // 4 for client
  // 5 for admin

  if (type === 'snr_marketer') {
    return (
      <div className="left_navbar">
        <h1>Welcome, {name}</h1>
        <div className="nav_links_wrapper">
          <NavLink className="nav_link " to="dashboard">
            <AiFillHome className="nav_icon" />
            <p>Overview</p>
          </NavLink>
          <NavbarDropdown
            label={({ show }) => (
              <div className="nav_link">
                <HiOfficeBuilding className="nav_icon" />
                <p>Office Assignments</p>
                {show ? <FaChevronDown className="drop_icon" /> : <FaChevronRight className="drop_icon" />}
              </div>
            )}
            routesToCheck={['assign-office', 'reassign-office', 'workload', 'office-status']}>
            <NavLink className="nav_link " to="assign-office">
              <p>Assign Office</p>
            </NavLink>
            <NavLink className="nav_link " to="workload">
              <p>Workload</p>
            </NavLink>
            <NavLink className="nav_link " to="office-status">
              <p>Office Status</p>
            </NavLink>
          </NavbarDropdown>

          <NavLink className="nav_link " to="scheduled-meetings">
            <AiOutlineCalendar className="nav_icon" />
            <p>Meetings</p>
          </NavLink>
          <NavLink className="nav_link " to="call-status">
            <BsTelephoneFill className="nav_icon" />
            <p>Call Status</p>
          </NavLink>
          <NavbarDropdown
            label={({ show }) => (
              <div className="nav_link">
                <CgMediaLive className="nav_icon" />
                <p>Subscription</p>
                {show ? <FaChevronDown className="drop_icon" /> : <FaChevronRight className="drop_icon" />}
              </div>
            )}
            routesToCheck={['sub']}>
            <NavLink className="nav_link " to="sub/bpo-farm">
              <p>BPO Farm Agent</p>
            </NavLink>
            <NavLink className="nav_link " to="sub/premier-agent-website">
              <p>Premier Agent Website</p>
            </NavLink>
            <NavLink className="nav_link " to="sub/deal-analyzer">
              <p>Deal Analyzer</p>
            </NavLink>
            <NavLink className="nav_link " to="sub/combo-package">
              <p>Combo Package</p>
            </NavLink>
          </NavbarDropdown>

          <div className="hr">
            <hr />
          </div>
        </div>
      </div>
    );
  }
  if (type === 'marketer') {
    return (
      <div className="left_navbar">
        <h1>Welcome, {name}</h1>
        <div className="nav_links_wrapper">
          <NavLink className="nav_link " to="marketing-exec-dashboard">
            <AiFillHome className="nav_icon" />
            <p>Home</p>
          </NavLink>
          <NavLink className="nav_link " to="my-tasks">
            <FaTasks className="nav_icon" />
            <p>My Tasks</p>
          </NavLink>
          <NavLink className="nav_link " to="compensation">
            <FaMoneyBillWave className="nav_icon" />
            <p>Compensation</p>
          </NavLink>
          {isUsAgent && (
            <>
              <NavLink className="nav_link " to="availability">
                <BsCalendar3 className="nav_icon" />
                <p>Availability</p>
              </NavLink>
              <NavLink className="nav_link " to="my-links">
                <BsGlobe className="nav_icon" />
                <p>My Links</p>
              </NavLink>
            </>
          )}

          <div className="hr">
            <hr />
          </div>
        </div>
      </div>
    );
  }

  if (type === 'admin') {
    return (
      <div className="left_navbar">
        <h1>Welcome, {name}!</h1>
        <div className="nav_links_wrapper">
          <NavLink className="nav_link " to="/operations-overview">
            <AiFillHome className="nav_icon" />
            <p>Overview</p>
          </NavLink>

          <NavbarDropdown
            label={({ show }) => (
              <div className="nav_link">
                <BsFillPersonBadgeFill className="nav_icon" />
                <p>Adminstration</p>
                {show ? <FaChevronDown className="drop_icon" /> : <FaChevronRight className="drop_icon" />}
              </div>
            )}
            routesToCheck={['executive', 'agent-offices', 'mart-exec-teams', 'submitted-offices']}>
            <NavLink className="nav_link " to="executive/snr-mark-execs">
              <p>Snr Marketing Executives</p>
            </NavLink>
            <NavLink className="nav_link " to="executive/mark-execs">
              <p>Marketing Executives</p>
            </NavLink>
            <NavLink className="nav_link " to="agent-offices">
              <p>Agent Offices</p>
            </NavLink>
            <NavLink className="nav_link " to="mart-exec-teams">
              <p>Marketing Executive Team</p>
            </NavLink>
            <NavLink className="nav_link " to="submitted-offices">
              <p>Submitted Offices</p>
            </NavLink>
          </NavbarDropdown>
          <NavbarDropdown
            label={({ show }) => (
              <div className="nav_link">
                <AiOutlineTeam className="nav_icon" />
                <p>Team Management</p>
                {show ? <FaChevronDown className="drop_icon" /> : <FaChevronRight className="drop_icon" />}
              </div>
            )}
            routesToCheck={['assign-mk-to-team', 'assign-team-to-snr-marketer', 'assign-office-to-team']}>
            <NavLink className="nav_link " to="assign-mk-to-team">
              <p>Assign Mkt. Exe to Teams</p>
            </NavLink>
            <NavLink className="nav_link " to="assign-team-to-snr-marketer">
              <p>Assign Teams to Snr. Mkt. Exe</p>
            </NavLink>
            <NavLink className="nav_link " to="assign-office-to-team">
              <p>Assign Office to Teams</p>
            </NavLink>
          </NavbarDropdown>
          <NavbarDropdown
            label={({ show }) => (
              <div className="nav_link">
                <FiTarget className="nav_icon" />
                <p>Sales Target</p>
                {show ? <FaChevronDown className="drop_icon" /> : <FaChevronRight className="drop_icon" />}
              </div>
            )}
            routesToCheck={['sales-target', 'teams-progress']}>
            <NavLink className="nav_link " to="sales-target">
              <p>Create Sales Target</p>
            </NavLink>
            <NavLink className="nav_link " to="teams-progress">
              <p>Teams' Progress</p>
            </NavLink>
          </NavbarDropdown>
          <NavbarDropdown
            label={({ show }) => (
              <div className="nav_link">
                <BiBarChart className="nav_icon" />
                <p>Subscriptions</p>
                {show ? <FaChevronDown className="drop_icon" /> : <FaChevronRight className="drop_icon" />}
              </div>
            )}
            routesToCheck={['subscription-overview']}>
            <NavLink className="nav_link " to="subscription-overview/BPO-farm-agent">
              <p>BPO Farm Agent </p>
            </NavLink>
            <NavLink className="nav_link " to="subscription-overview/BPO-premier-agent">
              <p>BPO Premier Agent</p>
            </NavLink>
            <NavLink className="nav_link " to="subscription-overview/BPO-deal-analyzer">
              <p>BPO Deal Analyzer</p>
            </NavLink>
            <NavLink className="nav_link " to="subscription-overview/BPO-combo-package">
              <p>BPO Combo Package</p>
            </NavLink>
          </NavbarDropdown>
          <NavLink className="nav_link " to="/compensation-report">
            <BsCardChecklist className="nav_icon" />
            <p>Report</p>
          </NavLink>
          <NavLink className="nav_link " to="/report-comps">
            <FaMoneyBillWave className="nav_icon" />
            <p>BPO Payment Requests</p>
          </NavLink>
        </div>
      </div>
    );
  }
};

export default LeftNavBar;
